import { Box } from "@mui/material";

import translations from "translations";
import { ErrorReportsFilterDataLoader } from "./ErrorReportsFilterDataLoader";
import ErrorReportFilter from "./ErrorReportFilter";
export { default as useCustomFilterbar } from "./useCustomFilterbar";

interface ErrorReportFilterToolbarProps {}

const ErrorReportFilterToolbar: React.FC<ErrorReportFilterToolbarProps> = () => {
  return (
    <Box>
      <ErrorReportsFilterDataLoader />
      <ErrorReportFilter
        filterType="errorReportStatus"
        title={translations.pages.certificationManagement.filterTitles.errorReportStatus}
      />
    </Box>
  );
};

export default ErrorReportFilterToolbar;
